export default __webpack_public_path__ + "static/media/potato_salad.a75c0b31.png";